/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Jumpy_Cowfish_AssureInputs */

const en_hour_jumpy_cowfish_assure = /** @type {(inputs: Hour_Jumpy_Cowfish_AssureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const de_hour_jumpy_cowfish_assure = /** @type {(inputs: Hour_Jumpy_Cowfish_AssureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Hour_Jumpy_Cowfish_AssureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const hour_jumpy_cowfish_assure = /** @type {((inputs?: Hour_Jumpy_Cowfish_AssureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Jumpy_Cowfish_AssureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hour_jumpy_cowfish_assure(inputs)
	return de_hour_jumpy_cowfish_assure(inputs)
});